export function buscarAnaliseAcaoGeral(idenPtaMonitora, page) {
  return new Promise((resolve, _reject) => {
    window.$http.get(`/analiseacaos/analiseGeral/listar/${idenPtaMonitora}?page=${page}&size=10`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarAnaliseAcaoDevolutiva(idenPtaMonitora, page) {
  return new Promise((resolve, _reject) => {
    window.$http.get(`/analiseacaos/analiseDevolutivo/listar/${idenPtaMonitora}?page=${page}&size=10`).then((res) => {
      resolve(res.data);
    });
  });
}

export function updatedAnaliseGeralAcao({ idenAnaliseAcao, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseacaos/${idenAnaliseAcao}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseGeralAcao(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseacaos/incluirAnaliseGeral`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseGeralPrograma(postBody) {  
   return new Promise((resolve, _reject) => {
     window.$http.post(`/analiseindicadors/incluirAnaliseGeral`, JSON.stringify(postBody)).then((res) => {
       resolve(res.data);
     });
   });
}

export function updatedAnaliseGeralPrograma({ idenAnaliseIndicador, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseindicadors/${idenAnaliseIndicador}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseProgramaGeral(idenAnaliseIndicador) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseindicadors/${idenAnaliseIndicador}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseDevolutivaProgramaIndicador(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseindicadors/incluirDevolutivo`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function updatedAnaliseDevolutivoProgramaIndicador({ idenAnaliseIndicador, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseindicadors/${idenAnaliseIndicador}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseDevolutivoProgramaIndicador(idenAnaliseIndicador) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseindicadors/${idenAnaliseIndicador}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseAcaoGeral(idenAnaliseAcao) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseacaos/${idenAnaliseAcao}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseDevolutivaAcao(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseacaos/incluirDevolutivo`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function updatedAnaliseDevolutivoAcao({ idenAnaliseAcao, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseacaos/${idenAnaliseAcao}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseDevolutivaAcao(idenAnaliseAcao) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseacaos/${idenAnaliseAcao}`).then((res) => {
      resolve(res.data);
    });
  });
}
